import { faArrowLeft, faSync } from '@fortawesome/free-solid-svg-icons';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import { EAlertType } from 'enums/alertType';
import { fireAlert } from 'functions/fireAlert';
import { useIsHandlerLoaded } from 'hooks/useIsLoading';
import * as ErpRecipe from 'types/Recipe/Detail/ErpNew/ErpRecipe';

type IProps = RecipeErpViewComponentProps & {
	erpRecipe: ErpRecipe.Type;
};

export const ButtonGroup = (props: IProps) => {
	const { classes } = useStyles();
	const { t } = useTranslation();

	const [isLoaded, saveErpRecipe] = useIsHandlerLoaded(async () => {
		await props.handlers.saveErpRecipe(props.erpRecipe.id ?? undefined);
		fireAlert(
			EAlertType.success,
			t('_general:BTN_SAVE'),
			t('recipe:RECIPE_PRODUCT_MAPPING_SAVE_MESSAGE')
		);
	});

	return (
		<div className={classes.buttonGroup}>
			<button
				type="button"
				className="btn btn-primary"
				onClick={props.handlers.navigateBackToOverview}
				disabled={!isLoaded}
			>
				<FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '7px' }} />
				{t('_general:BACK')}
			</button>
			<button
				type="button"
				className="btn btn-primary"
				onClick={() => saveErpRecipe()}
				disabled={!isLoaded}
			>
				<RenderIf condition={!isLoaded}>
					<FontAwesomeIcon
						className="fa-spin"
						icon={faSync}
						style={{ marginRight: '5px' }}
					/>
				</RenderIf>
				<RenderIf condition={isLoaded}>
					<FontAwesomeIcon icon={faSave} style={{ marginRight: '7px' }} />
				</RenderIf>
				{t('_general:BTN_SAVE')}
			</button>
		</div>
	);
};

const useStyles = tss.create({
	buttonGroup: {
		display: 'flex',
		gap: '5px',
		'> button': {
			minWidth: '140px',
		},
	},
});
